import { extractNamesFromSessionLicenses } from './components/SessionLicenses/utils/sessionLicensesUtil';

export const getSessionInformationFromSession = (
  session: Session | undefined,
): SessionInformation | undefined => {
  if (!session) return undefined;

  const { sessionDetails } = session;

  const formattedApexDemoMode = sessionDetails.apexDemo
    ? `${sessionDetails.apexDemo?.mode
        .charAt(0)
        .toUpperCase()}${sessionDetails.apexDemo?.mode.slice(1).toLowerCase()}`
    : undefined;

  return {
    apexDemoMode: formattedApexDemoMode,
    apexDemoName: sessionDetails.apexDemo?.name,
    apexDemoSubModeName: sessionDetails.apexDemo?.subModeName,
    endTime: sessionDetails.stop,
    lastModified: sessionDetails.updated,
    licenses: extractNamesFromSessionLicenses(sessionDetails.sessionLicenses),
    owner: sessionDetails.owner,
    parentDemo: sessionDetails.parentDemoName,
    sessionId: sessionDetails.id,
    virtualCenter: sessionDetails.virtualCenterId,
    vpnAvailable: !!sessionDetails.anyConnect,
  };
};

export const determineIsApexDemo = (data?: Session): boolean => {
  if (data === undefined || data.sessionDetails === undefined) return false;

  return Object.hasOwn(data.sessionDetails, 'apexDemo');
};
